import * as RootStoreState from './root-state';
import { RootStoreModule } from './root-store.module';
export { RootStoreState,RootStoreModule };
